"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Number = void 0;
var react_1 = __importDefault(require("react"));
var numberUtil = __importStar(require("../../util/number"));
function Number(props) {
    var value = props.value, placeholder = props.placeholder, title = props.title, abbrev = props.abbrev, prefix = props.prefix, suffix = props.suffix, formatOptions = props.formatOptions;
    var renderTitle = function () {
        return title || (abbrev && numberUtil.format(value));
    };
    var renderNumber = function () {
        if (typeof value !== 'number' || isNaN(value)) {
            return placeholder;
        }
        var num = abbrev ? numberUtil.abbrev(value, formatOptions) : numberUtil.format(value, formatOptions);
        return prefix + num + suffix;
    };
    return react_1.default.createElement("span", { title: renderTitle() }, renderNumber());
}
exports.Number = Number;
Number.defaultProps = {
    placeholder: '',
    prefix: '',
    suffix: '',
};
//# sourceMappingURL=Number.js.map